






































import { ValidationProvider } from 'vee-validate'
import Vue from 'vue'
import UiInputFile from '../../UiInputFile'
import UiFormField from '../UiFormField'
export default (Vue as typeof UiFormField).extend({
  name: 'UiFormFileUpload',
  components: {
    UiInputFile
  },
  extends: UiFormField,
  computed: {
    accept (): string {
      return this.field.properties?.allowedMimeTypes?.join(',')
    },
    listeners (): Record<string, any> {
      return {
        ...this.$listeners,
        input: this.onChange,
        change: this.onChange
      }
    },
    provider (): Vue & InstanceType<typeof ValidationProvider> {
      return this.$refs.provider as Vue & InstanceType<typeof ValidationProvider>
    }
  },
  watch: {
    innerValue (newVal): void {
      if (newVal === '') {
        (this.$refs.input as Vue & InstanceType<typeof UiInputFile>).reset()
      }
    }
  },

  methods: {
    async onChange (event: any): Promise<void> {
      if (!this.provider.flags.dirty) {
        this.provider.setFlags({ dirty: true })
      }
      if (event.target.files?.length) {
        const { valid } = await this.provider.validate(event)
        if (valid) {
          this.$emit('input', event.target.value)
        }
      } else {
        await (this.provider as Vue & InstanceType<typeof ValidationProvider>).reset()
        this.$emit('input', event.target.value)
      }
    }
  }
})
